<template>
  <div>
    <div>
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData" size="mini" label-width="90px">
          <div class="formItemBox">
            <el-form-item label="出库单号:">
              <el-input v-model="formData.outstockNo" placeholder="请输入出库单号"></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-select filterable clearable placeholder="请选择一级货主" v-model="formData.primaryCustomerTaxId">
                <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-select clearable filterable placeholder="请选择二级货主" v-model="formData.customerTaxId">
                <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库时间:" >
              <div style="display: flex;">
                <el-date-picker v-model="formData.outstockDateStart" type="datetime" placeholder="选择出库时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                -
                <el-date-picker v-model="formData.outstockDateEnd" placeholder="选择出库时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="客户单号:">
              <el-input v-model="formData.outBillNo" placeholder="请输入客户单号"></el-input>
            </el-form-item>
            <el-form-item label="提货单号:">
              <el-input v-model="formData.billNo" placeholder="请输入提货单号"></el-input>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable>
                <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地:">
              <el-select v-model="formData.placeOfOrigin" @change='steelMillNameChange' clearable placeholder="请选择" filterable>
                <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格:">
              <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable>
                <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="材质:">
              <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable>
                <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input v-model="formData.outstockPlateNumber" placeholder="请输入车号"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" >
              <div style="display: flex;">
                <el-date-picker v-model="formData.createTimeStart" type="datetime" placeholder="请选择创建时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                -
                <el-date-picker v-model="formData.createTimeEnd" placeholder="请选择创建时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </div>
              <!-- <el-form-item label="提货客户:">
                <el-select
                size="mini"
                clearable
                filterable
                placeholder="请选择提货客户"
                v-model="formData.pickupCustomerTaxId"
                >
                  <el-option
                    v-for="(item, index) in HZData"
                    :key="index"
                    :label="item.custerName"
                    :value="item.taxpayerNumber"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
            </el-form-item>
            <el-form-item label="车船编号:">
              <el-input v-model="formData.vehicleNumber" placeholder="请输入车船号"></el-input>
            </el-form-item>
          </div>
          <el-form-item style="padding-left: 10px;">
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB008" v-if="btnFlg[7]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB009" v-if="btnFlg[8]">重置</el-button>
            <el-button type="primary" size="mini" @click="revokeBtn" btnCode="00cP00BB00A" v-if="btnFlg[9]">撤销</el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB00B" v-if="btnFlg[10]">导出</el-button>
            <el-button type="primary" size="mini" @click="beizhuBtn"  btnCode="00cM0D0200" v-if="btnFlg[40]">记录备注
            </el-button>
          </el-form-item>
          <div style="margin: 0 0 5px 10px">
            <span>总吨数:
              <span style="color:red">{{totalAllWeight}}</span>吨
            </span>
            <span>总件数:
              <span style="color:red">{{ totalNumber }}</span>件
            </span>
          </div>
        </el-form>
      </div>
      <div :style="{height:h}">
        <el-table border center bordersize="mini" :data="tableData" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @selection-change="selectGoods">
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="lookGoods(scope.row)" size="mini" v-show="scope.row.path">提货函</el-button>
              <el-button type="text" @click="lookMessage(scope.row)" size="mini">人车信息</el-button>
              <el-button type="text" @click="lookBD(scope.row)" size="mini" v-if="Number(scope.row.weighingWeight / 1) > 0">磅单</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockUserName" label="出库人" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单号" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="客户单号" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="车号" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220"></el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true" prop="pickupCustomerName" label="提货客户" width="220" ></el-table-column> -->
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="placeOfOrigin" label="产地" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="110"></el-table-column>
          <el-table-column prop="vehicleNumber" label="车船号" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" width="130"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" width="180"></el-table-column>
          <el-table-column prop="shipForecastNo" label="预报编号" align="center" width="260"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200"></el-table-column>
          <el-table-column label="司机确认时间" prop="driverConfirmDate" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column prop="pickupCustomerName" label="提货客户" width="180px"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" width="180"></el-table-column>
          <el-table-column prop="recordRemark" label="记录备注" :show-overflow-tooltip="true" align="center" width="150"></el-table-column>

        </el-table>
      </div>
      <div class="pags">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
    </div>
    <!-- 人车信息 -->
    <rcDialog v-if="RCVisible" :RCVisible.sync='RCVisible' :identityNo="identityNo" :vhcNo="vhcNo" :driverName="driverName" :telephone="telephone"></rcDialog>
    <!-- 查看磅单 -->
    <bdDialog v-if="BDVisible" :BDVisible.sync='BDVisible' :outstockSummaryId="outstockSummaryId"></bdDialog>
 <!-- 备注 -->
 <bei-zhu v-if="beizhuMark"  @shuaxin="chaxun" :beizhuMark.sync="beizhuMark" :beizhuName="beizhuName" :selectId="selectId"></bei-zhu>

  </div>
</template>

<script>
import { getRelationCustomer, JfgetOutStockExpList, getVirtualBalingList, getOutStockExpNumber, getSBillFileUrl, deleteOutStockExpForSummary } from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
// import rcDialog from '../../jfChuKuGuanLi/dialog/RCdialog.vue'
// import bdDialog from '../../jfChuKuGuanLi/dialog/BDImg.vue'
import rcDialog from '../../yycRuKu/yycChuanYun/dialog/RCdialog.vue'
import bdDialog from '../../yycRuKu/yycChuanYun/dialog/BDImg.vue'
import beiZhu from './beizhu.vue'

export default {
  name: 'CKRecord',
  components: { rcDialog, bdDialog, beiZhu },
  data () {
    return {
      beizhuMark: false,
      beizhuName: '出库记录YYC',
      selectList: [],
      selectId: [],
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      formData: {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        outstockPlateNumber: '',
        productType: '',
        placeOfOrigin: '',
        specification: '',
        model: '',
        billNo: '',
        outBillNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        pickupCustomerTaxId: '',
        vehicleNumber: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        '00cM0D0200',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        '00cM0D0100',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectList: [],
      selectionData: [],
      RCVisible: false,
      vhcNo: '',
      identityNo: '',
      telephone: '',
      driverName: '',
      BDVisible: false,
      outstockSummaryId: '',
      totalAllWeight: 0,
      totalNumber: 0
    }
  },
  props: {
    CKVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {

    beizhuBtn () {
      if (this.selectList.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.beizhuMark = true
        this.selectId = []
        this.selectList.forEach(item => {
          this.selectId.push(item.outstockSummaryId)
        })
      }
    },
    // 人车信息
    lookMessage (row) {
      this.RCVisible = true
      this.identityNo = row.idNumber
      this.vhcNo = row.outstockPlateNumber
      this.telephone = row.telephone
      this.driverName = row.driverName
    },
    // 提货函
    lookGoods (row) {
      if (row.path) {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: { path: res }
          })
        })
      }
    },
    // 磅单
    lookBD (row) {
      this.BDVisible = true
      this.outstockSummaryId = row.outstockSummaryId
    },
    // 总吨数，总件数
    getOutStockExpNumber () {
      getOutStockExpNumber(
        {
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          outstockPlateNumber: this.formData.outstockPlateNumber,
          productType: this.formData.productType,
          placeOfOrigin: this.formData.placeOfOrigin,
          specification: this.formData.specification,
          model: this.formData.model,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          outstockNo: this.formData.outstockNo,
          outstockDateStart: this.formData.outstockDateStart,
          outstockDateEnd: this.formData.outstockDateEnd,
          billNo: this.formData.billNo,
          outBillNo: this.formData.outBillNo,
          createTimeStart: this.formData.createTimeStart,
          createTimeEnd: this.formData.createTimeEnd,
          pickupCustomerTaxId: this.formData.pickupCustomerTaxId,
          vehicleNumber: this.formData.vehicleNumber
        }
      )
        .then(res => {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 列表查询
    JfgetOutStockExpLists () {
      JfgetOutStockExpList(
        {
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          outstockPlateNumber: this.formData.outstockPlateNumber,
          productType: this.formData.productType,
          placeOfOrigin: this.formData.placeOfOrigin,
          specification: this.formData.specification,
          model: this.formData.model,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          outstockNo: this.formData.outstockNo,
          outstockDateStart: this.formData.outstockDateStart,
          outstockDateEnd: this.formData.outstockDateEnd,
          billNo: this.formData.billNo,
          outBillNo: this.formData.outBillNo,
          createTimeStart: this.formData.createTimeStart,
          createTimeEnd: this.formData.createTimeEnd,
          pickupCustomerTaxId: this.formData.pickupCustomerTaxId,
          vehicleNumber: this.formData.vehicleNumber
        }
      )
        .then(res => {
          this.tableData = res.list
          this.total = res.total
          this.getOutStockExpNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectList = selection
    },
    handleClicktab (tab, event) {
      // this.getControlAuditLists()
    },
    chaxun () {
      this.JfgetOutStockExpLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.outstockPlateNumber = ''
      this.formData.productType = ''
      this.formData.placeOfOrigin = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.outstockNo = ''
      this.formData.outstockDateStart = ''
      this.formData.outstockDateEnd = ''
      this.formData.billNo = ''
      this.formData.outBillNo = ''
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.pickupCustomerTaxId = ''
      this.formData.vehicleNumber = ''
      this.JfgetOutStockExpLists()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportOutStockExpList',
        { ...this.formData, instockStatus: '1' },
        '出库记录表'
      )
    },
    // 撤销
    revokeBtn () {
      if (this.selectList.length != 1) {
        this.$message.error('请选择一条数据进行撤销')
      } else {
        this.$confirm('撤销后数据不可恢复，确定撤销吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.tabLoading = true
          deleteOutStockExpForSummary({
            outstockSummaryId: this.selectList[0].outstockSummaryId
          })
            .then((res) => {
              this.tabLoading = false
              this.$message.success('撤销成功')
              this.JfgetOutStockExpLists(this.formData)
            })
            .catch((err) => {
              this.tabLoading = false
              this.$message.error(err.message)
            })
        }).catch(() => {
        })
      }
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetOutStockExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetOutStockExpLists()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getRelationCustomerS()
    this.JfgetOutStockExpLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  }
}
</script>

<style>
</style>
